import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators, Dispatch, Action } from 'redux'
import { IApplicationState } from '@Site/rootReducer'
import Popup from '@SiteComponents/Popup'
import Button from '@SiteComponents/Button'

import {
  deleteLabel,
} from '@SiteModules/Label/actions'

import {
  IDeleteLabelPayload,
} from '@SiteModules/Label/types'

import AttentionIcon from '@Images/attention.svg'

import './DeleteLabelPopup.scss'

interface DeleteLabelPopupProps {
  readonly editingLabelCaption: string
  readonly loading: boolean
  readonly editingLabelId: number
  closePopup(): void
  deleteLabel(payload: IDeleteLabelPayload): void
}

interface DeleteLabelPopupState {
  readonly deleteConfirmation: string
}

class DeleteLabelPopup extends React.Component<DeleteLabelPopupProps, DeleteLabelPopupState> {
  state = {
    deleteConfirmation: ''
  }

  changeDeleteCofirmation = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      deleteConfirmation: (e.target as HTMLInputElement).value
    })
  }

  handleConfirm = () => {
    const canDelete = this.state.deleteConfirmation === 'delete' || this.state.deleteConfirmation === 'DELETE'

    if (canDelete) {
      this.props.deleteLabel({ labelId: this.props.editingLabelId, caption: this.props.editingLabelCaption })
    }
  }

  render() {
    const { closePopup, loading, editingLabelCaption } = this.props
    const { deleteConfirmation } = this.state
    const canDelete = this.state.deleteConfirmation === 'delete' || this.state.deleteConfirmation === 'DELETE'
    const shouldDisableButton = !canDelete || loading

    return (
      <Popup
        className="DeleteLabelPopup"
        closePopup={closePopup}
      >
        <div className="DeleteLabelPopup__title">Delete the label</div>
        <p className="DeleteLabelPopup__description">
          <AttentionIcon className="DeleteLabelPopup__description__icon" />
          Warning, you will delete the label<br />
          “{editingLabelCaption}”.
        </p>
        <p className="DeleteLabelPopup__description">
          Type “delete” below to validate this action.
        </p>

        <input className="DeleteLabelPopup__confirmation"
          placeholder="delete"
          value={deleteConfirmation}
          onChange={this.changeDeleteCofirmation}
        />

        <Button
          styleType="brand"
          size="large"
          caption="Confirm the action"
          onClick={this.handleConfirm}
          disabled={shouldDisableButton}
        />
      </Popup>
    )
  }
}

function mapStateToProps(state: IApplicationState) {
  const { labels, popup } = state

  return {
    loading: labels.loading,
    editingLabelId: popup.editingLabelId,
    editingLabelCaption: popup.editingLabelCaption
  }
}

function mapDispatchToProps(dispatch: Dispatch<Action>) {
  return bindActionCreators({
    deleteLabel,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteLabelPopup)
